import React, { memo } from "react";
import {
  Stack,
  Card,
  Box,
  Typography,
  TextField,
  Avatar,
  CardContent,
  Divider,
  InputBase,
} from "investira.react.components";

import { PageTemplate } from "../../components/templates";

const InformacoesPessoais = memo(() => {
  return (
    // TODO: Implementar um container responsivo
    <Stack sx={{ width: "70%", margin: "0 auto" }}>
      <PageTemplate title="Informações Pessoais">
        <Stack spacing={3}>
          <Stack>
            <Card>
              <CardContent>
                <Typography variant="h6" color="textPrimary" gutterBottom>
                  Informações básicas
                </Typography>
                <Box component="form" noValidate>
                  <Stack direction="row" spacing={3} alignItems="center" mb={2}>
                    <Typography
                      variant="caption"
                      color="textPrimary"
                      gutterBottom
                    >
                      Foto do perfil
                    </Typography>
                    <Avatar />
                  </Stack>
                  <Divider />

                  <Stack direction="row" spacing={3} alignItems="center" mt={3}>
                    <Stack sx={{ width: "200px" }}>
                      <Typography
                        component="label"
                        variant="caption"
                        color="textPrimary"
                      >
                        Nome completo
                      </Typography>
                    </Stack>
                    <Stack flexGrow={1}>
                      <InputBase
                        id="nome"
                        name="nome"
                        placeholder="Fulano de Oliveira"
                      />
                    </Stack>
                  </Stack>
                  <Divider />
                  <Stack direction="row" spacing={3} alignItems="center" mt={3}>
                    <Stack sx={{ width: "200px" }}>
                      <Typography
                        component="label"
                        variant="caption"
                        color="textPrimary"
                      >
                        CPF
                      </Typography>
                    </Stack>
                    <Stack flexGrow={1}>
                      <InputBase
                        id="cpf"
                        name="cpf"
                        placeholder="123.456.789-09"
                      />
                    </Stack>
                  </Stack>
                  <Divider />
                </Box>
              </CardContent>
            </Card>
          </Stack>
          <Stack>
            <Card>
              <CardContent>
                <Typography variant="h6" color="textPrimary" gutterBottom>
                  Informações de contato
                </Typography>

                <Box component="form" noValidate>
                  <Stack direction="row" spacing={3} alignItems="center" mt={3}>
                    <Stack sx={{ width: "200px" }}>
                      <Typography
                        component="label"
                        variant="caption"
                        color="textPrimary"
                      >
                        Email
                      </Typography>
                    </Stack>
                    <Stack flexGrow={1}>
                      <InputBase
                        id="email"
                        name="email"
                        placeholder="investira@investira.com"
                      />
                    </Stack>
                  </Stack>
                  <Divider />
                  <Stack direction="row" spacing={3} alignItems="center" mt={3}>
                    <Stack sx={{ width: "200px" }}>
                      <Typography variant="caption" color="textPrimary">
                        Telefone
                      </Typography>
                    </Stack>
                    <Stack flexGrow={1}>
                      <InputBase
                        id="nome"
                        name="nome"
                        placeholder="(21) 88888-8888"
                      />
                    </Stack>
                  </Stack>
                  <Divider />
                </Box>
              </CardContent>
            </Card>
          </Stack>
          <Stack>
            <Card>
              <CardContent>
                <Typography variant="h6" color="textPrimary" gutterBottom>
                  Endereço
                </Typography>
                <Stack direction="row" spacing={3} alignItems="center" mt={3}>
                  <Stack sx={{ width: "200px" }}>
                    <Typography variant="caption" color="textPrimary">
                      Cobrança
                    </Typography>
                  </Stack>
                  <Stack flexGrow={1}>
                    <InputBase
                      id="cobranca"
                      name="cobranca"
                      placeholder="Nenhum endereço de cobrança cadastrado"
                    />
                  </Stack>
                </Stack>
                <Divider />
              </CardContent>
            </Card>
          </Stack>
        </Stack>
      </PageTemplate>
    </Stack>
  );
});

export default InformacoesPessoais;
